// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + {"12":"profiler","9777":"recorder"}[chunkId] + "." + {"12":"caae895329eb0c6c","9777":"9d5dbcfa139af129"}[chunkId] + ".js";
};